"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeSkin = exports.ThemeOptions = void 0;
var ThemeOptions;
(function (ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions = exports.ThemeOptions || (exports.ThemeOptions = {}));
// The skins of a theme, format is {baseTheme}-{varientName}
var ThemeSkin;
(function (ThemeSkin) {
    ThemeSkin["GREEN"] = "light-green";
})(ThemeSkin = exports.ThemeSkin || (exports.ThemeSkin = {}));
//# sourceMappingURL=constants.js.map